export enum ComponentStyle {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger',
  IconDanger = 'icon-danger',
  Link = 'link'
}
